module.exports = __webpack_public_path__ + "img/icons/new/slightly-rounded-corner-4f17170c543947243d35f46b5a7f9626.svg";